import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { SettingsLink, useSettingsNavigate } from '@frontend/settings-routing';
import { SettingsGroup } from '@frontend/settings-ui';
import { IndexRow } from '@frontend/design-system';

export const MultiLocationTextConnectSettings = () => {
  const { navigate } = useSettingsNavigate();
  const { t } = useTranslation('schedule-settings');
  const { selectedLocationIds, getScopeName } = useAppScopeStore();

  const route = '/messaging/text-connect/:locationId';

  const navigateTo = (locationId: string) => {
    navigate({
      to: route,
      params: { locationId: locationId ?? '' },
    });
  };

  return (
    <SettingsGroup title={t('Location Settings')}>
      <IndexRow>
        {selectedLocationIds?.map((locationId) => (
          <IndexRow.Item key={locationId} as={SettingsLink} to={route} onClick={() => navigateTo(locationId)}>
            <IndexRow.Item.Title>{getScopeName(locationId)}</IndexRow.Item.Title>
          </IndexRow.Item>
        ))}
      </IndexRow>
    </SettingsGroup>
  );
};
